export const INTERFACE_THEMES = Object.freeze([
  { value: 'system', previewClass: 'bg-n-surface-1' },
  { value: 'light', previewClass: 'bg-white' },
  { value: 'dark', previewClass: 'bg-slate-900' },
  { value: 'mist', previewClass: 'bg-slate-50' },
  { value: 'warm', previewClass: 'bg-yellow-50' },
  { value: 'sky', previewClass: 'bg-woot-50' },
  { value: 'mint', previewClass: 'bg-n-teal-3' },
]);

export const normalizeInterfaceTheme = theme => {
  const normalizedTheme = theme === 'graphite' ? 'dark' : theme;
  return INTERFACE_THEMES.some(item => item.value === normalizedTheme)
    ? normalizedTheme
    : 'system';
};

export const getInterfaceThemePreviewClass = theme =>
  INTERFACE_THEMES.find(item => item.value === normalizeInterfaceTheme(theme))
    ?.previewClass;
